import { Icon } from "@blueprintjs/core";
import { type IconName } from "@blueprintjs/icons";
import { get } from "lodash";
import { useMemo } from "react";
import { type TriviaHelp, useTriviaContext } from "../context-trivia";

type TriviaButtonHelpProps = {
  help: TriviaHelp;
  icon: IconName;
  text: string;
  onHandleMouse: (help: TriviaHelp) => void;
};

export function TriviaButtonHelp({
  help,
  icon,
  text,
  onHandleMouse,
}: TriviaButtonHelpProps) {
  const { availableTriviaHelp, screen } = useTriviaContext();
  const color = useMemo<string>(
    () => get(screen, "flyout.post.customData.buttonColorText"),
    [screen],
  );
  const disabled = useMemo<boolean>(
    () => !availableTriviaHelp.includes(help),
    [availableTriviaHelp, help],
  );

  return (
    <button
      className="font-bold w-full h-full text-4xl"
      disabled={disabled}
      style={{
        color,
        opacity: disabled ? 0.5 : 1,
      }}
      onPointerDown={() => onHandleMouse(help)}
    >
      <Icon icon={icon} size={72} />
      <div>{text}</div>
    </button>
  );
}
